import type {
  ReservationSlotTemplate,
  ReservationSlotTemplateInput,
} from '../../domain/reservationSlots';
import type { ReservationSlotTemplateRepository } from './ports/ReservationSlotTemplateRepository';

/**
 * 解放枠テンプレートを保存するUseCase（新規作成 or 更新）
 *
 * @description
 * id が指定された場合は更新、未指定の場合は新規作成を行う。
 *
 * @param {ReservationSlotTemplateRepository} repository - Repository実装（DI）
 * @param {ReservationSlotTemplateInput} input - 入力データ
 * @param {string} [id] - 更新対象のテンプレートID（新規作成時は省略）
 * @returns {Promise<ReservationSlotTemplate>} 保存後のテンプレート
 */
export async function saveTemplate(
  repository: ReservationSlotTemplateRepository,
  input: ReservationSlotTemplateInput,
  id?: string
): Promise<ReservationSlotTemplate> {
  if (id) {
    return repository.update(id, input);
  }
  return repository.create(input);
}
